import React from 'react';
import './EmptyDisplay.css';

const EmptyDisplay = () => {
  return (
    <div className="empty-display">
      <p>
        MORE BLOGS COMING SOON!
      </p>

    </div>
  )
}

export default EmptyDisplay